// actions.ts
import { Context, IRegisterApplicantActionPayload, IActions } from './actions.types'
import { RootState } from '@/store/types'
import { IRegistrationInfoData } from '@/entities'
import { ActionTree } from 'vuex';


export const actions: IActions = {
  /** register applicant */
  registerApplicant (context: Context, payload: IRegisterApplicantActionPayload): any {
    return this.$services.registrationInfo.registerApplicant(payload.registrationInfo);
  }
}